<template>
    <button class="nav-control btn align-items-center my-auto" @click="toggleSidebar" type="button" data-toggle="minimize">
        <i class="fa-solid" :class="{ 'fa-bars': !expandSidebar, 'fa-bars-staggered': expandSidebar }"></i>
    </button>
</template>

<script setup>
import {
    inject
} from 'vue';

const expandSidebar = inject('expandSidebar');

const toggleSidebar = () => {
    expandSidebar.value = !expandSidebar.value; // Toggle the sidebar state
    updateDropdowns(); // Update dropdowns on toggle
};
const updateDropdowns = () => {
    if (expandSidebar.value === true) {
        const sidebarDropdowns = document.querySelectorAll('.sidebar-dropdown');
        sidebarDropdowns.forEach(dropdown => {
            const hasActiveLink = dropdown.querySelector('.router-link-exact-active');
            if (hasActiveLink) {
                dropdown.classList.add('collapse', 'show');
            }
        });
    }
};
</script>
